// ── OCC Options Symbol Parser ────────────────────────────────────────────────
// Parses OCC format (from Schwab) into IBKR contract fields.
// OCC format: up to 6-char root (space-padded) + YYMMDD + C/P + 8-digit strike (strike × 1000)
// Example: "TSLA  260515P00370000" → { underlying: "TSLA", expiry: "20260515", right: "P", strike: 370 }

export function parseOCC(occSymbol) {
  if (!occSymbol) return null
  const trimmed = occSymbol.trim()
  const match = trimmed.match(/^(.{1,6}?)\s*(\d{6})([CP])(\d{8})$/)
  if (!match) return null
  const [, root, dateStr, right, strikeStr] = match
  return {
    underlying: root.trim(),
    expiry: '20' + dateStr,
    right,
    strike: parseInt(strikeStr, 10) / 1000,
  }
}

export function isOCCSymbol(symbol) {
  if (!symbol) return false
  return symbol.trim().length >= 15 && /\d{6}[CP]\d{8}$/.test(symbol.trim())
}

export function occIdentityKey(occSymbol) {
  const parsed = parseOCC(occSymbol)
  if (!parsed) return null
  return `${parsed.underlying.toUpperCase()}|${parsed.expiry}|${parsed.right}|${parsed.strike}`
}

/**
 * Formats an OCC option symbol into a human-readable string.
 * "TSLA  260515P00370000" → "TSLA 05/15/26 370 P"
 */
export function formatOCC(occSymbol) {
  const parsed = parseOCC(occSymbol)
  if (!parsed) return occSymbol?.trim() || '—'
  const { underlying, expiry, right, strike } = parsed
  const mm = expiry.slice(4, 6)
  const dd = expiry.slice(6, 8)
  const yy = expiry.slice(2, 4)
  const strikeStr = strike % 1 === 0 ? strike.toFixed(0) : String(strike)
  return `${underlying} ${mm}/${dd}/${yy} ${strikeStr} ${right}`
}
